// assessmentSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrl from "../../services/api";

export const getAssessmentQuestions = createAsyncThunk(
  "assessment/questions",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.questions, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "questions not loaded");
    }
  }
);

export const getManagersList = createAsyncThunk(
  "list/managers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.managers, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "questions not loaded");
    }
  }
);

export const submitAssessmentAnswers = createAsyncThunk(
  "answers/assessment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.submitAnswers, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "answers not submitted");
    }
  }
);
export const verifyCandidateOtp = createAsyncThunk(
  "otp/verify",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.verifyOtp, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "otp not verified");
    }
  }
);

export const resendCandidateOtp = createAsyncThunk(
  "otp/resend",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.resendOtp, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "resend otp failed");
    }
  }
);

export const updateTestStatus = createAsyncThunk(
  "assessment/status",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.updateStatus, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "resend otp failed");
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
  managerList: null,
  submitResult: null,
  otpverification: null,
  resendOtp:null
};

const assessmentSlice = createSlice({
  name: "assessment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssessmentQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAssessmentQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(getAssessmentQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(getManagersList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getManagersList.fulfilled, (state, action) => {
        state.loading = false;
        state.managerList = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(getManagersList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(submitAssessmentAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitAssessmentAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.submitResult = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(submitAssessmentAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(verifyCandidateOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyCandidateOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpverification = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(verifyCandidateOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(resendCandidateOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resendCandidateOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otpverification = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(resendCandidateOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(updateTestStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTestStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.otpverification = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(updateTestStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      });
  },
});

export default assessmentSlice.reducer;
